import { createReducer } from "@reduxjs/toolkit";

const initialState = {
    isLoading: false,
    sale: null,
    singleStoreSales: [],
    cashierSales: [],
    latestSale: null,
    sales: [],
    success: false,
    error: null,
    message: null,
};

export const salesReducer = createReducer(initialState, (builder) => {
    builder
        // Create Sale
        .addCase('createSaleRequest', (state) => {
            state.isLoading = true;
        })
        .addCase('createSaleSuccess', (state, action) => {
            state.isLoading = false;
            state.sale = action.payload;
            state.success = true;
        })
        .addCase('createSaleFail', (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
            state.success = false;
        })
        // Add Sale
        .addCase('addSaleRequest', (state) => {
            state.isLoading = true;
        })
        .addCase('addSaleSuccess', (state, action) => {
            state.isLoading = false;
            state.sale = action.payload;
            state.success = true;
        })
        .addCase('addSaleFail', (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
            state.success = false;
        })
        // Reprint receipt for an existing sale
        .addCase('reprintReceiptRequest', (state) => {
            state.isLoading = true;
        })
        .addCase('reprintReceiptSuccess', (state, action) => {
            state.isLoading = false;
            state.message = action.payload;
            // Don't set success = true to avoid triggering cart clear
        })
        .addCase('reprintReceiptFail', (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        })
        // Get Sales by Store
        .addCase('getSalesByStoreRequest', (state) => {
            state.isLoading = true;
        })
        .addCase('getSalesByStoreSuccess', (state, action) => {
            state.isLoading = false;
            state.singleStoreSales = action.payload;
        })
        .addCase('getSalesByStoreFail', (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        })

        // Get Sale by ID
        .addCase('getSaleByIdRequest', (state) => {
            state.isLoading = true;
        })
        .addCase('getSaleByIdSuccess', (state, action) => {
            state.isLoading = false;
            state.sale = action.payload;
        })
        .addCase('getSaleByIdFailed', (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        })

        // Edit Sale
        .addCase('editSaleRequest', (state) => {
            state.isLoading = true;
        })
        .addCase('editSaleSuccess', (state, action) => {
            state.isLoading = false;
            state.sale = action.payload;
            state.success = true;
        })
        .addCase('editSaleFailed', (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
            state.success = false;
        })

        // Delete Sale
        .addCase('deleteSaleRequest', (state) => {
            state.isLoading = true;
        })
        .addCase('deleteSaleSuccess', (state, action) => {
            state.isLoading = false;
            state.message = action.payload;
            state.success = true;
        })
        .addCase('deleteSaleFailed', (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
            state.success = false;
        })

        // Get Sales by Staff
        .addCase('getSalesByStaffRequest', (state) => {
            state.isLoading = true;
        })
        .addCase('getSalesByStaffSuccess', (state, action) => {
            state.isLoading = false;
            state.sales = action.payload;
        })
        .addCase('getSalesByStaffFail', (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        })

        // Get Sales by Cashier
        .addCase('getSalesByCashierRequest', (state) => {
            state.isLoading = true;
        })
        .addCase('getSalesByCashierSuccess', (state, action) => {
            state.isLoading = false;
            state.cashierSales = action.payload;
        })
        .addCase('getSalesByCashierFail', (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        })

        // Get Latest Sale
        .addCase('getLatestSaleRequest', (state) => {
            state.isLoading = true;
        })
        .addCase('getLatestSaleSuccess', (state, action) => {
            state.isLoading = false;
            state.latestSale = action.payload;
        })
        .addCase('getLatestSaleFail', (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        })

        // Legacy: Get All Sales
        .addCase('getAllSalesRequest', (state) => {
            state.isLoading = true;
        })
        .addCase('getAllSalesSuccess', (state, action) => {
            state.isLoading = false;
            state.sales = action.payload;
        })
        .addCase('getAllSalesFailed', (state, action) => {
            state.isLoading = false;
            state.error = action.payload;
        })

        // Clear Errors
        .addCase('clearErrors', (state) => {
            state.error = null;
        })

        // Clear Success Messages
        .addCase('clearSuccess', (state) => {
            state.message = null;
            state.success = false;
        });
});
